import {
  COLORS,
  Colors,
} from 'pages/Finance/CumulativeReport/components/CumulativeReportDatagrid/constants/colors';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { CumulativeReport } from 'types/embedded/cumulativeReport';
import { formatCurrency } from 'utils';

type Props = {
  color?: Colors;
  valueKey: keyof CumulativeReport;
} & Omit<FunctionFieldProps, 'render'>;

export const CumulativeReportDatagridSummaryField: React.FC<Props> = ({
  color = 'default',
  label,
  valueKey,
}) => {
  return (
    <FunctionField
      label={label}
      render={(record: CumulativeReport) => {
        return (
          <Stack direction="column">
            <Typography sx={{ color: COLORS[color], textWrap: 'nowrap', fontSize: 14 }}>
              {formatCurrency(Number(record[valueKey]))}
            </Typography>
          </Stack>
        );
      }}
    />
  );
};
